// Global theme configuration
export const theme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 8,
    colorBgContainer: '#ffffff',
    colorText: '#2c3e50',
    colorTextSecondary: '#596677',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Card: {
      borderRadius: 12,
    },
  },
};

// Reusable styles
export const globalStyles = {
  gradients: {
    // primary: 'linear-gradient(120deg, #14C38E 0%, #00A97F 100%)',
      primary2: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
  },
  shadows: {
    small: '0 2px 8px rgba(0,0,0,0.05)',
    medium: '0 4px 12px rgba(0,0,0,0.05)',
    large: '0 8px 16px rgba(0,0,0,0.1)',
  },
  spacing: {
    page: '0 50px',
    section: '80px 0',
    element: '24px',
  },
  cards: {
    default: {
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      transition: 'all 0.3s ease',
    },
    hover: {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    },
  },
  text: {
    title: {
      color: '#2c3e50',
      marginBottom: '24px',
    },
    subtitle: {
      color: '#596677',
      fontSize: '20px',
      marginBottom: '40px',
    },
  },
  layout: {
    maxWidth: '1800px',
    headerHeight: '64px',
  },
};
